export default __webpack_public_path__ + "static/media/ellipse.8c29c164.svg";